interface Point {
    x: number
    y: number
}

export function clamp(input: number, min: number, max: number): number {
    return Math.max(Math.min(input, max), min)
}

export function roundToDecimal(value: number, decimals: number): number {
    const factor = Math.pow(10, decimals)
    return Math.round(value * factor) / factor
}

export function getDistance(point1: Point, point2: Point): number {
    return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2))
}

export function lerp(start: number, end: number, t: number): number {
    return start + (end - start) * t
}
